export const PICTURE = 'Billede';
export const FLOORPLAN = 'Plantegning';
export const VIDEO = 'Video';
export const DEG720 = '720°';
export const VR = 'Interaktiv præsentation';
export const SLIDESHOW = 'Slideshows';
export const VISUALIZATION = 'Visualisering';
export const MATTERPORT = 'Matterport';
